interface SegmentedFieldProps {
    label: string
    status: boolean | undefined
}
export const SegmentedField = ({status, label}: SegmentedFieldProps) => {
    return (
        <div className="flex flex-col gap-1">
            <p className="ml-5 text-text-disabled text-sm">{label}</p>
            <div className="flex flex-row bg-primary-white rounded-2xl p-1 justify-between">
                <div className={`p-4 flex flex-row rounded-2xl items-center justify-center flex-1 ${status === undefined ? 'bg-primary-black text-primary-white' : ''}`}>
                    <p className="text-xl">N/A</p>
                </div>
                <div className={`p-4 flex flex-row rounded-2xl items-center justify-center flex-1 ${status === false ? 'bg-primary-black text-primary-white' : ''}`}>
                    <p className="text-xl">No</p>
                </div>
                <div className={`p-4 flex flex-row rounded-2xl items-center justify-center flex-1 ${status ? 'bg-action-primary' : ''}`}>
                    <p className="text-xl">Yes</p>
                </div>
            </div>
        </div>
    )
}